import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-informe-preliminar',
  templateUrl: './informe-preliminar.component.html',
  styleUrls: ['./informe-preliminar.component.scss'],
})
export class InformePreliminarComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      descripcion: [values ? values.descripcion : '', [Validators.required]],
      n_oficio: [values ? values.n_oficio : '', [Validators.required]],
    });
  }
  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
